import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShoppingBag, BookMarked } from "lucide-react";

export default function MarketplaceComingSoon() {
    const { t } = useTranslation();
    return (
        <main
            data-testid="marketplace-coming-soon"
            className="min-h-[calc(100vh-73px)] flex items-center justify-center px-5 py-16"
        >
            <section className="max-w-xl text-center">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-[var(--border-strong)] mb-8">
                    <ShoppingBag size={22} strokeWidth={1.2} className="text-[var(--accent)]" />
                </div>
                <p className="text-xs uppercase tracking-[0.3em] text-[var(--accent)] mb-4">
                    {t("marketplace_soon.eyebrow")}
                </p>
                <h1
                    className="font-display text-4xl md:text-5xl text-[var(--ink)] tracking-tight mb-5"
                    style={{ fontVariationSettings: '"wght" 700, "wdth" 80, "opsz" 144' }}
                >
                    {t("marketplace_soon.title")}
                </h1>
                <p className="text-[var(--ink-muted)] text-lg leading-relaxed mb-10">
                    {t("marketplace_soon.lead")}
                </p>
                <Link
                    to="/"
                    data-testid="marketplace-soon-home-link"
                    className="inline-flex items-center gap-2 text-sm uppercase tracking-widest text-[var(--ink-muted)] hover:text-[var(--accent)] transition-colors"
                >
                    <BookMarked size={14} strokeWidth={1.5} />
                    {t("marketplace_soon.cta_home")}
                </Link>
            </section>
        </main>
    );
}
